// frontend/src/components/GoogleLoginButton.js

import React, { useContext } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode'; // Corrected Import
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

const GoogleLoginButton = () => {
  const { login } = useContext(AuthContext);

  const handleSuccess = async (credentialResponse) => {
    try {
      const { credential } = credentialResponse;
      
      // Decode the credential to log the user info (for debugging)
      const decoded = jwtDecode(credential);

      // Send the credential to your backend
      const response = await axios.post(
        `${process.env.REACT_APP_GOOGLE_API_URL || 'http://localhost:5000'}/api/auth/google`,
        { token: credential },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true
        }
      );

      // Handle the response from your backend
      const { accessToken, refreshToken } = response.data; // **Destructure both tokens**
      
      if (!accessToken || !refreshToken) {
        throw new Error('No tokens received from server');
      }

      // Store the tokens and update auth context
      login({ accessToken, refreshToken }); // **Pass both tokens as an object**
      
    } catch (error) {
      console.error('Login failed:', error);
      if (error.response) {
        console.error('Server response:', error.response.data);
        console.error('Status code:', error.response.status);
      }
    }
  };

  const handleError = (error) => {
    console.error('Google Sign-In Error:', error);
  };

  return (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap={false}
        theme="filled_blue"
        text="continue_with"
        shape="rectangular"
        locale="en"
        scope="email profile https://www.googleapis.com/auth/calendar.events"

      />
    </div>
  );
};

export default GoogleLoginButton;
